export const timezone_mapper_gmt = {
    "Dubai":"04:00",
    "India":"05:30",
    "UAE":"04:00",
    "Pakistan": "05:00",
    "England": "01:00",
    "West Indies": "05:30",
    "Australia": "11:00",
    "South Africa": "02:00",
    // For USA check for Day light saving.
    "USA":"04:00",
}
